export const METADATA_COLUMNS = new Set([
  "updated_at",
  "updated_by",
  "created_at",
  "created_by",
  "active_status",
  "enterprise_id",
  "serial_no",
  "enterprise_id",
  "bp_id",
  "id",
  "tenant_id",
  "transaction_id",
  "version",
]);

export const ROW_DATA_KEYS = {
  ID: "id",
  CREATED_BY: "created_by",
  DMS_GROUP_BUS_UNIT_ID: "dms_group_bus_unit_id",
  ACTIVE_STATUS: "active_status",
  ACCOUNT_TYPE: "account_type",
  CASH_STORE_ID: "cash_store_id",
  CASH_ACCOUNT: "cash_account",
  CASH_CLEARING_ACCOUNT: "cash_clearing_account",
  GROUP_ACCOUNTS: "group_accounts",
  REF_STORE: "ref_store",
  ROLE_LEVEL: "role_level",
  SUB_TYPE: "sub_type",
  ACCOUNTING_ACCOUNT: "accounting_account",
  COMPANY_B_STORE: "store_b_id",
  COMPANY_A_STORE: "store_a_id",
  CONVERSION_STATUS: "conversion_status",
  FORM_ID: "form_id",
  PROVISION_ID: "provision_id",
  ROUTE_NAME: "route_name",
  ROUTE_NAMES: "route_names",
  INVENTORY_ZONES: "zones",
  INVENTORY_ROUTES: "routes",
  JOURNAL_ID: "journal_id",
  LABOR_TYPE: "labor_type",
  LABOR_TYPE_DESCRIPTION: "description",
  DEFAULT_LABOR_TYPE: "default_labor_type",
  WRITEUP_TYPES: "writeup_type",
  CUSTOMER_PAY_TYPE: "customer_pay_type",
  WARRANTY_PAY_TYPE: "warranty_pay_type",
  INTERNAL_PAY_TYPE: "internal_pay_type",
  DISTRIBUTION_PERCENTAGE: "distribution_percentage",
  AR_SWITCH_STATUS: "switchStatus",
  AR_SWITCH_IN_PROGRESS: "switchInProgress",
  SCHEDULE_TYPE: "schedule_type",
  SCHEDULE_CODE: "schedule_code",
  NEW_SCHEDULE_CODE: "new_schedule_code",
  INTEGRATING_APPLICATION: "integrating_application",
  DISTRIBUTION: "distribution",
  GROUP_ADDRESSES: "group_addresses",
  RECURRING_ENTRY_REFERENCE: "recurring_entry_reference",
  POSTING_AMOUNT: "posting_amount",
  TRANSACTION_TYPE: "transaction_type",
  CASH_IN_BANK_COMPANY_GROUP_ID: "cash_in_bank_company_group_id",
  CASH_CLEARING_COMPANY_GROUP_ID: "cash_clearing_company_group_id",
  SOURCE_COMPANY_GROUP_ID: "source_company_group_id",
  TARGET_COMPANY_GROUP_ID: "target_company_group_id",
  STORE_B_ID: "store_b_id",
  IS_ENABLED: "is_enabled",
  MANUFACTURER_CODE: "manufacturer_code",
  IS_OVERTIME_CALCULATED: "is_overtime_calculated",
  PAY_PERIOD_TYPE: "pay_period_type",
  IS_PRIOR_DAYS_USE_FOR_OT: "is_prior_days_use_for_ot",
  JOURNAL_TEMPLATE_ENTRY_REFERENCE: "journal_template_entry_reference",
  DEFAULT_AMOUNT: "default_amount",
  DELETE_DATA: "delete_data",
};

// these keys are used to track the UI state of the record and will not be sent to the backend
export const TRACK_RECORD_DATA_STATE_KEYS = {
  TRACK_EXISTING_ID: "__existingRecordId",
  TRACK_EXISTING_CREATED_BY: "__existingRecordCreatedBy",
  TRACK_IS_CLONED_RECORD: "__isClonedRecord",
};

export const CUSTOM_MULTI_INPUT_COMPONENT_KEYS = [
  "payment_types", // Cash Receipt Payment Types
  "prompts", // Cash Receipt Payment Types
  "abbreviation_code", // ROSetups - concern_code
  "invoice_message", // Service Invoice
  "outstanding_campaign_numbers", // Service CampaignStatus
  "campaign_numbers", // Service CampaignStatus
  "trigger_labor_types", // Service SpecialFees
  "additional_labor_types", // Service SpecialFees
  "labor_types", //sublet markups
  "customers", //sublet markups
];
export const CUSTOM_MULTI_INPUT_REQUIRED_KEYS = [
  "payment_types", // Cash Receipt Payment Types
];

export const CUSTOM_MULTI_INPUT_CHIPS_COMPONENT_KEYS = [
  "company_type", // VendorCompanyType
  "category_description", // VendorCategory
  "chk_laser_printer_no", //Laser Form Table
];
export const CUSTOM_MULTI_INPUT_CHIPS_REQUIRED_KEYS = [
  "company_type", // VendorCompanyType
  "category_description", // VendorCategory
];

export const CUSTOM_PLAIN_TEXT_COMPONENT_KEYS = [
  "zones", // Inventory Buildings Zones tab
];

export const CUSTOM_CHECKBOX_LIST_COMPONENT_KEYS = [
  "route_names", // Inventory Buildings Routes tab
];

export const CUSTOM_LARGE_DATA_MULTI_SELECT_COMPONENT_KEYS = [
  "accounts", // Cash In Bank
];
export const CUSTOM_LARGE_DATA_MULTI_SELECT_REQUIRED_KEYS = [
  "accounts", // Cash In Bank
];

export const CUSTOM_MULTI_SELECT_REQUIRED_KEYS = [
  "accounts", // Cash In Bank (once we use RenderLargeDataMultiSelect component we can remove this from here)
  "group_accounts", // PO Configuration Group (Companies And Accounts Tab)
];
// Below Multivalued keys will supress the default typeAhead API call
export const CUSTOM_MULTIVALUED_KEYS_NEEDED_CUSTOM_OR_ENUM_DROPDOWN_OPTIONS = [
  "schedule_fields", // Accounts Receivable
  "aged_trial_balance_fields", // Accounts Receivable
  "acc_name", // PO Configuration Group (Companies And Accounts Tab)
  "group_accounts", // PO Configuration Group (Companies And Accounts Tab)
  "included_on", // Shop Charge Table
  "included_on", // Shop Charge Table
  "codes", // AlrtSeq
  "messages", // AlrtSeq
  "inquiry_status", // Campaign Status
  "status_of_technician", // Dispatch
  "labor_classes", // Sublet Markups
];

// AutoComplete fields which can also take userInput eding with *
export const EDITABLE_AUTOCOMPLETE_FIELD_KEYS = [
  "JournalTemplates-account_number",
];

export const EVALUATED_RESULT_KEYS = {
  PO_AUTHORITIES: "POAuthorities",
  FORM_ID_AND_PROVISION_ID_OPTIONS: "formIdAndProvisionIdOptions",
  INVENTORY_ZONES: "inventoryZones",
  INVENTORY_ROUTES: "inventoryRoutes",
  DEFAULT_LABOR_TYPE_OPTIONS: "defaultLaborTypeOptions",
  CUSTOMER_PAY_TYPE_OPTIONS: "customerPayTypeOptions",
  WARRANTY_PAY_TYPE_OPTIONS: "warrantyPayTypeOptions",
  INTERNAL_PAY_TYPE_OPTIONS: "internalPayTypeOptions",
  INTERCO_COMPANY_GROUP_ID_OPTIONS: "intercoCompanyGroupIdOptions",
};

export const DOLLAR_PREFIX_FOR_FIELDS = [
  "amount",
  "limit",
  "labor rate",
  "Maximum Price",
  "Minimum Price",
];

export const PERCENTAGE_SUFFIX_FIELDS = ["percentage", "percent"];

export const FORM_ID_AND_PROVISION_ID_LABEL_FIELDS = [
  "form_id",
  "provision_id",
];

// to add fields values of properties not present in schema
export const CUSTOM_ROWDATA_FIELDS_TO_ADD = ["LaserFormTable-departmentId"];

export const CURRENCY_FIELD_KEYS: string[] = [
  "amount_exception",
  "posting_amount",
];

export const CHECKBOX_FIELD_KEYS: string[] = ["is_posting_month_active"];

// to hide the disabled delete/add button in correlation fields
export const FIELD_KEYS_TO_HIDE_ACTIONS_WHEN_DISABLED = ["trade_discount"];

export const CORRELATION_ACTION_DISABLED_FIELD_KEYS = ["gl_calendar"];

export const ALL_SELECTION_ENABLED_FIELD_KEYS = ["account_details-journal_ids"];
